import { render, staticRenderFns } from "./exportData.vue?vue&type=template&id=5d6882ce&scoped=true&"
import script from "./exportData.vue?vue&type=script&lang=js&"
export * from "./exportData.vue?vue&type=script&lang=js&"
import style0 from "./exportData.vue?vue&type=style&index=0&id=5d6882ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6882ce",
  null
  
)

export default component.exports